export default "__VITE_ASSET__DLzAilKP__"